module.exports = __webpack_public_path__ + "img/banner.d72abb07.png";